import { PromoCards } from '@/entities/catalog-inside-page/PromoCards/ui/PromoCards'
import './ui/PromoCards.scss'
export default PromoCards
